import CustomBreadCrumb from '../../../components/Common/CustomBreadCrumb'
import DeliveryOrderList from '../../../components/Purchasing/DeliveryOrder/DeliveryOrderList'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function DeliveryOrder(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <CustomBreadCrumb
              items={[
                { text: 'Purchasing' },
                { text: 'Order' },
                { text: 'Delivery', link: '#/purchasing/delivery/list' },
              ]}
            />
            <PageTitle
              title={'Delivery'}
              subtitle={
                'An order to deliver items to a single final destination. Delivery order can be linked optionally to one sales order'
              }
              color={'#427035'}
              iconType={'export'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <DeliveryOrderList {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

export default DeliveryOrder
